import React, { useState } from 'react';
import Card from 'components/v2/card/Card';
import CardFooter from 'components/v2/card/CardFooter';
import CardHeader from 'components/v2/card/CardHeader';
import { useTranslation } from 'react-i18next';
import FSCSettingsForm from './FSCSettingsForm';
export default function AddFSCSettings({ accountId, data = {}, onCancel, onSave, }) {
    const { t } = useTranslation();
    const [saving, setSaving] = useState(false);
    function renderHeader() {
        return React.createElement(CardHeader, { title: t('ADD_FSC_SETTING') });
    }
    function renderFooter() {
        return (React.createElement(CardFooter, { onActionClick: () => setSaving(true), onCancelClick: onCancel, disabled: saving, actionTestDataId: "drayage-save-fsc-config", cancelTestDataId: "drayage-cancel-fsc-config" }));
    }
    return (React.createElement(Card, { header: renderHeader, footer: renderFooter },
        React.createElement(FSCSettingsForm, { accountId: accountId, data: data, saving: saving, onSaveSuccess: () => {
                setSaving(false);
                onSave();
            }, onSaveFail: () => setSaving(false) })));
}
